import { readRemoteFile } from "react-papaparse";

const SPREADSHEET_URL = `https://docs.google.com/spreadsheets/d/e/2PACX-1vTcHxcvlBbaP5pG3TTRuJATEUKoqdhxdTVROFWRDCiaCHbwvBlabD2hjuI5pKPP-EKbQmc31FvfKQ-g/pub?output=csv`;

var parameters = [
  "id",
  "nombre",
  "descripcion",
  "categoria",
  "url",
  "verificado",
  "favicon_url",
  "favicon_1",
  "favicon_3",
  "ia"
];

// Fetch vaccines data from spreadsheet
export async function getData() {
  const data = await new Promise((resolve, reject) => {
    readRemoteFile(SPREADSHEET_URL, {
      complete: (results) => {
        resolve(results);
      },
    });
  });
  let rows = data["data"].slice(1, data.length);
  console.log(rows);
  let vaccines = [];
  rows.forEach((row) => {
    var vaccine = {};
    for (let i = 0; i < parameters.length; i++) {
      vaccine[parameters[i]] = row[i];
    }
    vaccines.push(vaccine);
  });
  console.log(vaccines);
  return vaccines;
}
